import * as THREE from 'three';

export class InputHandler {
    constructor(player, camera) {
        this.player = player;
        this.camera = camera;
        this.enabled = false;
        
        this.keys = {
            w: false,
            a: false,
            s: false,
            d: false,
            space: false,
            q: false,
            e: false
        };
        
        this.mousePressed = false;
        
        this.setupEventListeners();
    }
    
    setupEventListeners() {
        document.addEventListener('keydown', (e) => this.onKeyDown(e));
        document.addEventListener('keyup', (e) => this.onKeyUp(e));
        document.addEventListener('mousedown', (e) => this.onMouseDown(e));
        document.addEventListener('mouseup', (e) => this.onMouseUp(e));
    }
    
    onKeyDown(event) {
        if (!this.enabled) return;
        
        const key = event.key.toLowerCase();
        
        switch(key) {
            case 'w':
                this.keys.w = true;
                break;
            case 'a':
                this.keys.a = true;
                break;
            case 's':
                this.keys.s = true;
                break;
            case 'd':
                this.keys.d = true;
                break;
            case ' ':
                this.keys.space = true;
                this.player.jump();
                break;
            case 'q':
                this.keys.q = true;
                this.useAbility1();
                break;
            case 'e':
                this.keys.e = true;
                this.useAbility2();
                break;
        }
    }
    
    onKeyUp(event) {
        if (!this.enabled) return;
        
        const key = event.key.toLowerCase();
        
        switch(key) {
            case 'w':
                this.keys.w = false;
                break;
            case 'a':
                this.keys.a = false;
                break;
            case 's':
                this.keys.s = false;
                break;
            case 'd':
                this.keys.d = false;
                break;
            case ' ':
                this.keys.space = false;
                break;
            case 'q':
                this.keys.q = false;
                break;
            case 'e':
                this.keys.e = false;
                break;
        }
    }
    
    onMouseDown(event) {
        if (!this.enabled) return;
        
        if (event.button === 0) { // Left click
            this.mousePressed = true;
        }
    }
    
    onMouseUp(event) {
        if (event.button === 0) {
            this.mousePressed = false;
        }
    }
    
    useAbility1() {
        // Q ability - depends on evolution
        if (this.player.traits.tentacles) {
            console.log('Using tentacle grab!');
            
            // Find closest enemy in front of player (within 30 units)
            const playerPos = this.player.camera.position;
            const forward = new THREE.Vector3();
            this.player.camera.getWorldDirection(forward);
            
            // Access enemy manager from window.game
            if (!window.game || !window.game.enemyManager) return;
            
            let closestEnemy = null;
            let closestDistance = 30; // Max range
            
            window.game.enemyManager.enemies.forEach(enemy => {
                if (enemy.isDead) return;
                
                const enemyPos = enemy.mesh.position;
                const distance = playerPos.distanceTo(enemyPos);
                
                // Check if enemy is in front of player
                const toEnemy = new THREE.Vector3();
                toEnemy.subVectors(enemyPos, playerPos).normalize();
                const dotProduct = forward.dot(toEnemy);
                
                if (dotProduct > 0.5 && distance < closestDistance) { // In front (roughly 60 degree cone)
                    closestEnemy = enemy;
                    closestDistance = distance;
                }
            });
            
            if (closestEnemy) {
                // Animate tentacle to enemy
                this.player.useTentacleGrab(closestEnemy.mesh.position);
                
                // Deal damage after tentacle reaches (300ms)
                setTimeout(() => {
                    if (!closestEnemy.isDead) {
                        closestEnemy.takeDamage(40); // Strong attack!
                        if (window.game && window.game.audioManager) {
                            window.game.audioManager.playHit();
                        }
                    }
                }, 300);
            }
        }
    }
    
    useAbility2() {
        // E ability - depends on evolution
        if (this.player.traits.wings) {
            console.log('Using wing boost!');
            this.player.velocity.y = 15;
        }
    }
    
    update(deltaTime) {
        if (!this.enabled) return;
        
        // Movement
        if (this.keys.w) {
            this.player.moveForward(1);
        }
        if (this.keys.s) {
            this.player.moveForward(-1);
        }
        if (this.keys.a) {
            this.player.moveRight(-1);
        }
        if (this.keys.d) {
            this.player.moveRight(1);
        }
        
        // Shooting
        if (this.mousePressed) {
            this.player.shoot();
        }
    }
}
